import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslocoRootModule } from 'src/app/transloco/transloco-root.module';
import { AuthInterceptor } from '../auth/auth.interceptor';
import { PrimeNgModule } from './components/PrimeNg.module';
import { HeaderComponent } from './header/header.component';
import { LoadingComponent } from './loading/loading.component';

@NgModule({
    declarations: [
        HeaderComponent,
        LoadingComponent
        /* FooterComponent, */
    ],
    imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        FormsModule,
        /* ---interface--- */
        PrimeNgModule,
        /* tradução */
        TranslocoRootModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        }
    ],
    exports: [
        HeaderComponent,
        LoadingComponent
        /*  FooterComponent, */
    ]
})
export class SharedCommonModule { }
